import {useCallback, useContext, useEffect, useState} from 'react';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';

export const useImageRotate = () => {
  const {canvas} = useContext(EventCreateContext);

  const [rotationValue, setRotationValue] = useState(0);

  const getActiveUyoImage = useCallback(() => {
    if (!canvas) return null;

    const activeObj = canvas.getActiveObject();
    if (!activeObj) return null;
    if (activeObj.type !== 'uYOImage') return null;

    return activeObj;
  }, [canvas]);

  const getRotateValue = useCallback(() => {
    const activeUyoImage = getActiveUyoImage();
    if (!activeUyoImage) return 0;

    return activeUyoImage.angle % 360;
  }, [getActiveUyoImage]);

  useEffect(() => {
    const activeObj = canvas?.getActiveObject();
    if (activeObj?.type === 'uYOImage') {
      let angle = activeObj.angle % 360;
      if (angle > 180) angle -= 360;
      if (angle < -180) angle += 360;
      setRotationValue(Math.round(angle));
    }
  }, [canvas]);

  const handleRotationChange = useCallback(
    (value) => {
      setRotationValue(Number(value));
      const activeObj = canvas.getActiveObject();
      if (activeObj && activeObj.type === 'uYOImage') {
        activeObj.set({angle: Number(value)});
        canvas.renderAll();
        canvas.fire('object:modified');
      }
    },
    [canvas]
  );

  useEffect(() => {
    if (!canvas) return undefined;

    const resetHandler = () => {
      setRotationValue(0);
    };

    const rotationHandler = () => {
      const scale = getRotateValue();
      setRotationValue(Math.round(scale));
    };

    canvas.on('object:modified', rotationHandler);
    canvas.on('object:reseted:uyo', resetHandler);

    return () => {
      canvas.off('object:reseted:uyo', resetHandler);
      canvas.off('object:modified', rotationHandler);
    };
  }, [canvas, getRotateValue]);

  return {
    rotationValue,
    handleRotationChange,
  };
};
